/**
 * User: Michael.Schaubruch
 * Date: 14.02.2020
 * Time: 17:01
 */


// https://alligator.io/vuejs/global-event-bus/

// import Vue from 'vue';
// export const EventBus = new Vue();

import Vue from 'vue';

const EventBus = new Vue();
export default EventBus;
